module.exports = __webpack_public_path__ + "img/wicked-logo.fb46cf74.png";